import extendString from "@ep/extends/String";
import extendHTMLElement from "@ep/extends/HTMLElement";
import extendHTMLFormElement from "@ep/extends/HTMLFormElement";
import extendHTMLTableElement from "@ep/extends/HTMLTableElement";
import extendHTMLTableSectionElement from "@ep/extends/HTMLTableSectionElement";
import extendHTMLTableRowElement from "@ep/extends/HTMLTableRowElement";
import extendHTMLTableCellElement from "@ep/extends/HTMLTableCellElement";
import extendHTMLButtonElement from '@ep/extends/HTMLButtonElement';
import extendHTMLInputElement from "@ep/extends/HTMLInputElement";
import initEqualButtonGroups from '@ep/tools/equalizeButtonGroups';

/* ===== API publica ===== */
/**
 * Aplica extensões de protótipos usadas pela aplicação.
 * @public
 * @returns {void}
 */
const extend = () => {
  extendHTMLElement();
  extendHTMLFormElement();
  extendHTMLButtonElement();
  extendHTMLInputElement();
  extendHTMLTableElement();
  extendHTMLTableSectionElement();
  extendHTMLTableRowElement();
  extendHTMLTableCellElement();
  extendString();
  initEqualButtonGroups();
};

export default extend;
